<template>
    <div class="Classroom_list" v-loading="loading">
        <div class="Classroom_list_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span> > <span class="span2">个人法务</span>
             </div>
             <div class="check_box">
                <div class="check_felx">
                    <div class="check_title">一级分类</div>
                    <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}">
                        <div class="check_item" :class="{'check_item_ac':item.id==yjfl_ac.id}" v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':yjfl_show}" @click="handle_yjfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>
                <div class="check_felx">
                    <div class="check_title">二级分类</div>
                    <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                        <div class="check_item"  :class="{'check_item_ac':item.id==ejfl_ac.id}" v-for="(item,index) in ejfl_list" :key="index" @click="handle_ejfl(item)">{{ item.title }}</div>
                    </div>
                    <div class="check_show" :class="{'check_show2':ejfl_show}" @click="handle_ejfl_show">
                        <img src="@/assets/img/index/legal/check_show.png" alt="">
                    </div>
                </div>

                <div class="check_felx">
                    <div class="check_title">已选择</div>
                    <div class="check_ac_flex">
                        <!-- <div class="check_ac_text"></div> -->
                       
                        <div class="check_ac_box" v-if="yjfl_ac.id">
                            {{ yjfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                        </div>
                        <div class="check_ac_box" v-if="ejfl_ac.id">
                            {{ ejfl_ac.title }}
                            <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                        </div>


                        <div class="chack_ac_clear" @click="handle_clear">清空</div>
                    </div>
                </div>
             </div>
             <div class="list_box">
                <div class="list_left">
                    <div class="list_item" v-for="(item,index) in list" :key="index" @click="handle_detial(item)">
                        <div class="item_title">
                            {{ item.title }}
                        </div>
                        <div class="item_const">
                          {{ item.desc }}
                        </div>
                        <div class="item_btns">
                            <div class="nums">
                                <div class="user_img">
                                    <div class="imgs">
                                        <img src="../../../assets/img/index/home/users.png" alt="">
                                    </div>
                                    <div class="imgs">
                                        <img src="../../../assets/img/index/home/users.png" alt="">
                                    </div>
                                    <div class="imgs">
                                        <img src="../../../assets/img/index/home/users.png" alt="">
                                    </div>
                                    <div class="img_colo">···</div>
                                </div>
                                <div class="num_text">{{ item.answer_num }}位律师解答</div>
                            </div>
                            <div class="item_tages">
                                <div class="teges">
                                    <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                    {{ item.views }}
                                </div>
                                <div class="teges">
                                    <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                    {{ item.comment_num }}
                                </div>
                                <div class="teges">
                                    <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                    {{ item.pub_time }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pages_box">
                        <div class="btns" @click="handle_pages(1)">首页</div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            background
                            :page-size="pages.limit"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                        <div class="btns"  @click="handle_pages(last_page)">尾页</div>
                    </div>
                </div>
                <div class="list_right">
                    <Classroom_new ref="Classroom_new"></Classroom_new>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import Classroom_new from '@/components/law/Classroom/Classroom_new.vue'//右边

 

export default {
    components: {
        Classroom_new
    },
    name: "homes",
    data() {
        return {
            loading:false,
            yjfl_list:[],//办理地址列表
            yjfl_ac:{},//办理地址的选中
            yjfl_show:false,//办理地址的显示隐藏

            ejfl_list:[],//业务类型
            ejfl_ac:{},//业务类型的选中
            ejfl_show:false,//业务类型的显示隐藏
            list:[],
            total:0,
            last_page:1,
            pages:{
                page:1,
                limit:10,
            },
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_type_list()
    },
    methods: {
        ac_clear(text){
            this[text]={}
            if(text=='yjfl_ac'){
                this.ejfl_list=[]
                this.ejfl_ac={}
            }
            this.pages.page=1
            this.get_list()
 
        },
        handle_clear(){
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.pages.page=1
            this.get_list()
        },
        get_type_list(){
            this.loading=true
            this.$api("lessonTypeList", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂分类',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list(){
            this.loading=true
            this.$api("lessonList", {
                type:2,
                ...this.pages,
                cateid:this.yjfl_ac.id||0,
                cateid2:this.ejfl_ac.id||0,
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表1',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_yjfl(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={},
            this.pages.page=1
            this.get_list()

        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl(item){
            this.ejfl_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
        },
    
        //咨询
        handle_check(item){
            this.$refs.legal_check.handle_open()
        },
        handle_end(){
            console.log('回调')
        },
        //跳转详情
        handle_detial(item){
            this.$router.push({
                path:'/Classroom_list_text_detial',
                query:{
                    id:item.id
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.Classroom_list{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .Classroom_list_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;

                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
            }
        }
        .list_box{
            display: flex;
            justify-content: space-between;
            padding-top: 24px;
            .list_left{
                width: 1000px;
                // height: 2354px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                padding: 32px 32px 40px 32px ;
                .list_item{
                    padding-bottom: 32px; 
                    border-bottom: 1px solid #EEEEEE;
                    
                    margin-bottom: 32px;
                    .item_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                    }
                    .item_const{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        padding-top: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:2;
                        -webkit-box-orient: vertical;
                    }
                    .item_btns{
                        padding-top: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                       .nums{
                            width: 308px;
                            height: 56px;
                            background: linear-gradient( 90deg, #F5F5F5 0%, #FFFFFF 100%);
                            border-radius: 28px 28px 28px 28px;
                            padding: 12px 16px;
                            display: flex;
                            align-items: center;
                            .user_img{
                                display: flex;
                                align-items: center;
                                .imgs{
                                    width: 32px;
                                    height: 32px;
                                    margin-left: -8px;
                                    border: 1px solid #fff;
                                    border-radius: 50%;
                                }
                                .imgs:first-child{
                                    margin-left: 0;
                                }
                                .img_colo{
                                    width: 32px;
                                    height: 32px;
                                    // background: #FFFFFF;
                                    // background: rgba(0,0,0,0.3);
                                    background-color: #B2B2B2;
                                    border: 1px solid #FFFFFF;
                                    border-radius: 50%;
                                    // display: flex;
                                    // align-items: center;
                                    // justify-content: center;
                                    color: #FFFFFF;
                                    font-size: 30px;
                                    line-height: 28px;
                                    text-align: center;
                                    margin-left: -8px;
                                }
                            }
                            .num_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-left: 10px;
                            }
                       } 
                       .item_tages{
                            display: flex;
                            align-items: center;
                            
                            .teges{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-left: 24px;
                                img{
                                    height: 16px;
                                    margin-right: 8px;
                                }
                            }

                       }
                    }
                    
                }
            }
            .list_right{

            }

            
        }
        .pages_box{
            width: 100%;
            height: 100px;
            // background-color: red;
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/.el-pagination{
                .el-pager{
                    .number {
                        background-color: #FFFFFF;
                    }
                    .active{
                        background-color: #377CFD;
                    }
                }
            }
            .btns{
                width: 40px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #EEEEEE;  
                font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                font-weight: normal;
                font-size: 14px;
                color: #7A7A7A;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
         
        
        
    }
    
}

</style>